// extracted by mini-css-extract-plugin
export default {"stars":"zSIl1","stars__star":"cE6cw","skeleton-placeholder-pulse":"YVVIr","skeletonPlaceholderPulse":"YVVIr"};